<template>
  <div>
    <link rel="stylesheet" href="https://checkout.payoneer.com/paymentpage/v3/op-payment-widget-v3.min.css" />
    <el-dialog title="Payoneer" append-to-body :visible.sync="visible" :width="isPC ? '60%' : '100%'" custom-class="payoneer-dialod" destroy-on-close :close-on-click-modal="false" @close="dialogClose">
      <div v-loading="loading" style="max-width:800px">
        <div id="paymentNetworksId" className="payment-networks-container"></div>
        <div id="submitBtnContainerId" className="submit-buttons-container">
          <button id="submitBtnId" type="button" class="submit-button"></button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import { loadScript } from '@/util/index'
import { e } from 'mathjs'
loadScript('https://cdn.bootcdn.net/ajax/libs/jquery/3.6.4/jquery.min.js')
export default {
  props: {
    // 支付成功回调页面（绝对路径）
    payCallbackUrl: {
      type: String,
      require: true,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      paymentId: ''
    }
  },
  methods: {
    show(paymentId) {
      this.paymentId = paymentId
      this.visible = true
      this.loading = true
      if (window.checkoutList) {
        this.initPayoneer()
        return
      }
      loadScript('https://checkout.payoneer.com/paymentpage/v3/op-payment-widget-v3.min.js', () => {
        this.initPayoneer()
      })
    },
    initPayoneer() {
      API.getPaymentPayoneer({
        transactionId: this.paymentId,
        callback: {
          returnUrl: this.payCallbackUrl, // `/payment-status?orderId=${this.kkOrderId}`,
          cancelUrl: this.payCallbackUrl // `/payment-status?orderId=${this.kkOrderId}`
        }
      }).then(res => {
        if (res.code !== 10000) {
          if (res.code === 240026) {
            this.$emit('payoneerError')
          }
          // 定时器
          setTimeout(() => {
            this.$message.warning(res.message)
          }, 500)
          this.visible = false
          return
        }
        window.checkoutList('paymentNetworksId', {
          listUrl: res.data,
          payButton: 'submitBtnId',
          payButtonContainer: 'submitBtnContainerId',
          widgetCssUrl: 'op-payment-widget-v3/build/widget.css'
        })
      }).finally(() => {
        this.loading = false
      })
    },

    dialogClose() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
/* @import '../assets/css/payoneer/op-payment-widget-v3.min.css'; */
@import '../assets/css/payoneer/widget-card-view.min.css';
@import '../assets/css/payoneer/widget.min.css';
</style>
<style scoped  lang="scss">
/deep/ #paymentNetworksId {
  #testIndicatorBadge {
    display: none;
  }
  .formContainer {
    iframe {
      max-height: 160px;
    }
  }
  .op-payment-widget-container .formContainer .registration {
    margin: 20px 0;
    input {
      width: 20px;
    }
  }
}
/deep/ #submitBtnContainerId {
  text-align: center;
  .submit-button {
    padding: 10px /*25px*/ 80px; /* wider */
    font-weight: /*500*/ 600;   /* bolder */
    color: #fff;
    border-radius: 4px;
    font-size: 14px;
    margin: 20px 0;
    background: /*#54b94d*/ #9AC331; /* yellow */
  }
}
</style>

<style>
.payoneer-dialod {
  max-width: 850px !important;
}
</style>
